<template>
  <section id="Loader">
    <div class="container-md">
      <div class="row">
        <div class="col text-center">
          <img :src="appUrl + '/img/icons/spinner.svg'" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from "vuex";

export default {
  name: "spinner-loader",
  setup() {
    const store = useStore();
    const appUrl = store.getters["config/getAppUrl"];

    return {
      appUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
#Loader {
  img {
    display: inline-flex;
  }
}
</style>
